module.exports = "::ng-deep .cdk-overlay-pane {\n  background-color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/invoices-view/submit-vendor-invoice/submit-vendor-invoice.component.scss
// module id = ./src/app/pages/vendor/my-vendor/invoices-view/submit-vendor-invoice/submit-vendor-invoice.component.scss
// module chunks = main